import { useEffect } from 'react';
import { globalMediaEventEmitter, type MediaViewedEventPayload } from '@atlaskit/media-client';
import { notifyAttachmentViewed } from '../services/attachment-viewed-event-notification/index.tsx';

const AttachmentViewedStreamHubEvents = () => {
	useEffect(() => {
		const handleAttachmentViewedEvent = (event: MediaViewedEventPayload) => {
			if (['full', 'download'].includes(event?.viewingLevel)) {
				notifyAttachmentViewed(event?.fileId);
			}
		};
		globalMediaEventEmitter.on('media-viewed', handleAttachmentViewedEvent);

		return () => {
			globalMediaEventEmitter.off('media-viewed', handleAttachmentViewedEvent);
		};
	});
	return null;
};

export default AttachmentViewedStreamHubEvents;
